import React from 'react';
import { useTranslation } from 'react-i18next';
import { ShippingRate } from '../common/model/dto/shipping-rate/shipping-rate';
import { RecordColumn } from '../common/model/ui/record-list.type';
import DateUtils from '../common/utils/services/date-utils';
import StringUtils from '../common/utils/services/string-utils';
import OvPillLink from '../components/UI/atoms/OvPillLink';

export function useShippingRateListColumns(
  getNavigationState: () => unknown
): RecordColumn<ShippingRate>[] {
  const { t } = useTranslation();

  return [
    {
      id: 'internal-name',
      header: t('shippingRates.fields.internalName'),
      cardRole: 'heading',
      renderCell: (rate) => StringUtils.displayValue(rate.internal_name),
    },
    {
      id: 'display-name',
      header: t('shippingRates.fields.displayName'),
      renderCell: (rate) => StringUtils.displayValue(rate.display_name),
    },
    {
      id: 'display-price',
      header: t('shippingRates.fields.displayPrice'),
      renderCell: (rate) => StringUtils.displayValue(rate.display_price),
    },
    {
      id: 'is-active',
      header: t('shippingRates.fields.isActive'),
      renderCell: (rate) =>
        StringUtils.getPrettifiedBooleanValue(rate.is_active),
    },
    {
      id: 'created-at',
      header: t('shippingRates.fields.createdAt'),
      renderCell: (rate) =>
        DateUtils.formatDate(
          rate.created_at as Date,
          'MMMM DD, YYYY, HH:mm:ss'
        ),
    },
    {
      id: 'action',
      header: t('common.action'),
      isHeaderHidden: true,
      cardRole: 'footer',
      renderCell: (rate, detailsPath = '') => (
        <OvPillLink
          to={detailsPath}
          state={getNavigationState()}
          aria-label={t('shippingRates.detailsFor', {
            name: rate.internal_name,
          })}
        >
          {t('common.actions.seeDetails')}
        </OvPillLink>
      ),
    },
  ];
}
